import {Environment} from '@ui/schemes/app/environment'

export const env: Environment = {
  production: false,
  apiHost: 'https://app.dev.joo.kz',
}
